import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
function AddPurchase() {
    const [ldata, setLdata] = useState(null);
    const [doctor, setDoctor] = useState("");
    const [otUhidSuggestions, setOtUhidSuggestions] = useState([]);
     const [uhidErrorShown, setUhidErrorShown] = useState(false);
     const [showItemOptions, setShowItemOptions] = useState(false);
     const [itemSearch, setItemSearch] = useState("");

     const [items, setItems] = useState([]);
    const generateSaleNo = () => {
  return Math.floor(1000000 + Math.random() * 9000000); 
};

const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // YYYY-MM-DD format
};

    // const [department, setDepartment] = useState({});
    const [formData, setFormData] = useState({
        medicines: [
            {
                sn: 1,
                store_purchase_item_name: '',
                store_purchase_item_unit: '',
                store_purchase_item_rate: '',
                store_purchase_item_qty: '',
                store_purchase_item_dis: '',
                store_purchase_item_dis_amt: '',
                store_purchase_item_gst: '',
                store_purchase_item_total: '',
                store_purchase_item_gtotal:''
            }
        ],
        store_purchase_type:'storesale',
        store_purchase_id: '',
        store_purchase_no: generateSaleNo(),
        store_purchase_date: getTodayDate(),
        store_purchase_mode: '',
        store_invoice_number: '',
        store_invoice_date: '',
        store_purchase_vendor: '',
        store_purchase_total: '',
        store_purchase_gtotal:'',
        store_purchase_return_reason:'',
        store_purchase_dis: '',
        store_purchase_gst: '',
        store_purchase_user: '',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        isAlert: false,
    });

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if ((name + "").localeCompare("search_key") == 0) {
            initData();
        }
    };

    const handleChange1 = (e,index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        // alert(name+"");
        const name1 = name.replace(/[0-9]/g, "");

        // alert(name1+"");
        setFormData(prev => {
            const updatedItems = [...prev.medicines];
            updatedItems[index] = {
              ...updatedItems[index],
              [name1]: value
            };
        
            return {
              ...prev,
              medicines: updatedItems
            };
          });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();

        // purchase_type
        fd.append('store_purchase_id', formData.store_purchase_id);
        fd.append('store_purchase_no', formData.store_purchase_no);
        fd.append('store_purchase_type', formData.store_purchase_type);
        fd.append('store_purchase_date', formData.store_purchase_date);
        fd.append('store_purchase_mode', formData.store_purchase_mode);
        fd.append('store_invoice_number', formData.store_invoice_number);
        fd.append('store_invoice_date', formData.store_invoice_date);
        fd.append('store_purchase_vendor', formData.store_purchase_vendor);
        fd.append('store_purchase_total', formData.store_purchase_total);
        fd.append('store_purchase_dis', formData.store_purchase_dis);
        fd.append('store_purchase_gst', formData.store_purchase_gst);
        fd.append('store_purchase_gtotal', formData.store_purchase_gtotal);
        fd.append('store_purchase_return_reason', formData.store_purchase_return_reason);
        
        
        fd.append('store_items', JSON.stringify(formData.medicines) + "");
        fd.append('store_purchase_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addStorePurchaseUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                sessionStorage.removeItem("opd_dt")
                window.location.href = "/store_purchase";
            }
            else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }

    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            var fd = new FormData();
            fd.append('page_no', "0");
            fd.append('search_key', formData.search_key + "");
            fd.append('test_user', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            tests: records
                        }));
                        if (formData.items.length <= 0) {
                            setFormData(prev => ({
                                ...prev,
                                items: records
                            }));
                        }
                    }
                }
            } catch (error) {

            }

            fd = new FormData();
            fd.append('cat_type', "vital");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {

                    var records = response.data.records;
                    if (records != null && records != undefined) {
                        setFormData(prev => ({
                            ...prev,
                            vitals: records
                        }));
                    }
                }
            } catch (error) {

            }
        }
    };

     const initData2 = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
          const parsed = JSON.parse(storedData);
          const fd = new FormData();
          fd.append('type',  "doctor");
          fd.append('search_key', formData.search_key + "");
          fd.append('page_no', formData.page_no + "");
          fd.append('user_cre_by', 1 + "");
//           console.log({
//   type: formData.cat_type,
//   search_key: formData.search_key,
//   page_no: formData.page_no,
//   user_cre_by: 1
// });

          try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
            if (response.data.status) {
    
              var records = response.data.records;
              console.log("this is the data : " + JSON.stringify(records))
              if (records != null && records != undefined) {
                setDoctor(prev => ({
                  ...prev,
                  l1: records
                }));
              }
            }
          } catch (error) {
    
          }
    
          
        }
      };

          const initData5 = async () => {
              const storedData = sessionStorage.getItem("ldata");
              if (storedData) {
                  const parsed = JSON.parse(storedData);
                  var fd = new FormData();
                  fd.append('page_no', "0");
                  fd.append('search_key', formData.search_key + "");
                  fd.append('test_user', 1 + "");
                  try {
                      const response = await axios.post(AppConst.BASE_URL + AppConst.getTestListUrl, fd, {
                          headers: {
                              'Content-Type': 'multipart/form-data',
                          },
                      });
                      if (response.data.status) {
                          var records = response.data.records;
                          if (records != null && records != undefined) {
                              setFormData(prev => ({
                                  ...prev,
                                  tests: records
                              }));
                              if (formData.items.length <= 0) {
                                  setFormData(prev => ({
                                      ...prev,
                                      items: records
                                  }));
                              }
                          }
                      }
                  } catch (error) {}
      
                  fd = new FormData();
                  fd.append('cat_type', "vital");
                  fd.append('page_no', "none");
                  fd.append('search_key', "");
                  fd.append('par_by', 1 + "");
                  try {
                      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
                          headers: {
                              'Content-Type': 'multipart/form-data',
                          },
                      });
                      if (response.data.status) {
                          var records = response.data.records;
                          if (records != null && records != undefined) {
                              setFormData(prev => ({
                                  ...prev,
                                  vitals: records
                              }));
                          }
                      }
                  } catch (error) {}
              }
              if (storedData) {
                  const parsed = JSON.parse(storedData);
                  const fd = new FormData();
                  fd.append('type', "supplier1");
                  fd.append('search_key', formData.search_key + "");
                  fd.append('page_no', formData.page_no + "");
                  fd.append('user_cre_by', 1 + "");
                  try {
                      const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                          headers: {
                              'Content-Type': 'multipart/form-data',
                          },
                      });
                      console.log("supplier : " + JSON.stringify(response))
                      if (response.data.status) {
      
                          var records = response.data.records;
                          if (records != null && records != undefined) {
                              setFormData(prev => ({
                                  ...prev,
                                  suppliers: records
                              }));
                          }
                      }
                  } catch (error) {
      
                  }
              }
          };

          const initData3 = async() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            
            if(parsed!=null && parsed!=undefined){
                const fd = new FormData();
                fd.append('user_id', 1);
                try {
                    const response = await axios.post(AppConst.BASE_URL+AppConst.getStoreByIdUrl, fd, {
                        headers: {
                        'Content-Type': 'multipart/form-data',
                        },
                    });
                    if(response.data.status){
                        
                        var user_dt = response.data.user_dt;
                        if(user_dt!=null && user_dt!=undefined){
                            // console.log("this is user Data : " + JSON.stringify(user_dt.store_settings_department))
                             setFormData(prev => ({
                                ...prev,
                                store_invoice_number: user_dt.store_settings_department || ""
                            }));
                        }
                    }
                } catch (error) {
                    console.error("initData3 error:", error);
                }
            }
        }
      };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
            initData2();
            initData3();
            initData5()
        }

        if (
            sessionStorage.getItem("opd_dt") != null &&
            sessionStorage.getItem("opd_dt") != undefined &&
            sessionStorage.getItem("opd_dt").length > 0
        ) {
            var tmp = JSON.parse(sessionStorage.getItem("opd_dt") + "");
            if (tmp != null && tmp != undefined) {

                var items = tmp.items;

                setFormData(prev => ({
                    ...prev,
                    medicines:items,
                    store_purchase_id: tmp.store_purchase_id,
                    store_purchase_no: tmp.store_purchase_no,
                    store_purchase_type: tmp.store_purchase_type,
                    store_purchase_date: tmp.store_purchase_date,
                    store_purchase_mode: tmp.store_purchase_mode,
                    store_invoice_number: tmp.store_invoice_number,
                    store_invoice_date: tmp.store_invoice_date,
                    store_purchase_vendor: tmp.store_purchase_vendor,
                    store_purchase_total: tmp.store_purchase_total,
                    store_purchase_dis: tmp.store_purchase_dis,
                    store_purchase_gst: tmp.store_purchase_gst,
                    store_purchase_gtotal: tmp.store_purchase_gtotal,
                    store_purchase_return_reason: tmp.store_purchase_return_reason,
                    store_purchase_user: tmp.store_purchase_user,
                }));
            }
        }



        return () => {
            console.log('Component unmounted');
        };
    }, []);

   const searchOtUserNow = async () => {
    const uhid = formData?.ot_uhid_no?.trim() || ""; // agar undefined/null ho to empty string

    if (uhid.length < 6) {
        setOtUhidSuggestions([]);
        setUhidErrorShown(false);
        return;
    }

    try {
        const fd = new FormData();
       fd.append("lab_reg_uhid", uhid);
fd.append("search_type", "ipdbilling");

        const response = await axios.post(
            AppConst.BASE_URL + AppConst.searchUhidUrlCall,
            fd
        );

        if (response.data.status && response.data.records?.length > 0) {
            setOtUhidSuggestions(response.data.records);
            setUhidErrorShown(false);
        } else {
            setOtUhidSuggestions([]);
            if (!uhidErrorShown) {
                toast.error("UHID Does not exist in IPD!");
                setUhidErrorShown(true);
            }
        }
    } catch (error) {
        console.error("OT UHID Search Error:", error);
        setOtUhidSuggestions([]);
        if (!uhidErrorShown) {
            toast.error("ERROR !");
            setUhidErrorShown(true);
        }
    }
};
    



const handleSelectOtUser = async (user) => {
    console.log("Selected User:", JSON.stringify(user));
    if (!user || !user.lab_reg_uhid) return;

    try {
        setFormData(prev => ({
            ...prev,
            store_purchase_id: user.lab_reg_id || "",
            store_purchase_user: user.lab_reg_name || "",
            store_purchase_no: prev.store_purchase_no, // agar pehle generate kiya hua hai
            store_purchase_date: getTodayDate(),
            store_purchase_mode: user.lab_reg_mode || "",
            store_invoice_number: user.invoice_no || "",
            store_invoice_date: user.invoice_date || "",
            store_purchase_vendor: user.vendor_name || "",
            store_purchase_total: user.total_amount || "",
            store_purchase_gtotal: user.grand_total || "",
            store_purchase_return_reason: user.return_reason || "",
            store_purchase_dis: user.discount || "",
            store_purchase_gst: user.gst || "",

        }));

        toast.success(`${user.lab_reg_type} Patient data fetched successfully!`);
    } catch (err) {
        console.error("Error setting patient details:", err);
        toast.error("Failed to fetch patient details.");
    } finally {
        setOtUhidSuggestions([]);
    }
};


const handleItemSelect = (item) => {
  setFormData((prev) => ({
    ...prev,
    medicines: [
      ...prev.medicines,
      {
        store_purchase_item_name: item.store_item_name,
        store_purchase_item_unit: item.store_unit,          // ✅ API se aata hai
        store_purchase_item_rate: 0,                        // ✅ rate manually dalna padega ya user input karega
        store_purchase_item_qty: 1,
        store_purchase_item_dis: 0,
        store_purchase_item_dis_amt: 0,
        store_purchase_item_gst: item.store_igst,                         // ✅ agar GST API se nahi aata
        store_purchase_item_total: 0,                       // ✅ initially 0
        store_division: item.store_division,                // extra data (optional)
        store_batch_no: item.store_batch_no,                // extra data (optional)
        store_department: item.store_department,            // extra data (optional)
        store_hsn: item.store_hsn,                          // ✅ useful for GST calculation later
      },
    ],
  }));

  // input clear + dropdown close
  setItemSearch("");
  setShowItemOptions(false);
};


    // console.log("this is department" +  JSON.stringify(department))
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xxl-12">
                        <div class="card">
                            <div class="card-body">
                                <h5>New Sale</h5>
                                <br />
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">

                                                                                         <div className="col-md-4">
    {/* Wrapper div ko 'position-relative' banana zaroori hai */}
    <div className="mb-3 position-relative">
        <label htmlFor="ot-uhid-field" className="form-label">UHID Number</label>
        <input 
            id="ot-uhid-field"
            name="ot_uhid_no" 
            onChange={handleChange} 
            value={formData.ot_uhid_no} 
            className="form-control" 
            placeholder="Enter UHID Number" 
            type="text"
            // Naye functions ko yahan attach karein
            onKeyUp={searchOtUserNow}
            autoComplete="off"
            required
        />

        {/* Suggestion list ko yahan render karein */}
        {otUhidSuggestions.length > 0 && (
            <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
                {otUhidSuggestions.map((user, idx) => (
    <li
        key={idx}
        className="list-group-item list-group-item-action"
        onClick={() => handleSelectOtUser(user)}
        style={{ cursor: "pointer" }}
    >
        {user.lab_reg_uhid} - {user.lab_reg_name} 
        <span className="badge bg-info ms-2">{user.lab_reg_type}</span>
    </li>
))}
            </ul>
        )}
    </div>
</div>

                                              <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Patient Name</label>
                                                    <input name="ipd_bill_patient_name" onChange={handleChange} value={formData.ipd_bill_patient_name} class="form-control" placeholder="Enter Patient Name" type="text" required readOnly/>
                                                </div>
                                            </div>

                                             <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Age</label>
                                                    <input name="ipd_bill_patient_age" onChange={handleChange} value={formData.ipd_bill_patient_age} class="form-control" placeholder="Enter Age" type="text" required readOnly/>
                                                </div>
                                            </div>
                                            <div class="col-md-12"><br /></div>
                                              <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Gender</label>
                                                    <select class="form-control" data-trigger="" name="ipd_bill_patient_gender" onChange={handleChange} value={formData.ipd_bill_patient_gender} required readOnly>
                                                        <option value="Active">Male</option>
                                                        <option value="Deactive">Female</option>
                                                        <option value="Deactive">Other</option>

                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Patient Address</label>
                                                    <input name="ipd_bill_patient_address" onChange={handleChange} value={formData.ipd_bill_patient_address}
                                                        class="form-control" placeholder="Enter Patient Address" type="text" required readOnly/>
                                                </div>
                                            </div>

                                                 <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">OT Doctor</label>
                                                    <select class="form-control"  name="store_purchase_vendor" onChange={handleChange} value={formData.store_purchase_vendor}>
                                                    <option value="" selected>Select</option>
                                                        
                                                       {doctor?.l1 && Array.isArray(doctor?.l1) && doctor?.l1?.map((doc, index) => (
                                                            <option key={index} value={doc.doctor_id}>
                                                            {doc.fname}
                                                            </option>
                                                        ))}

                                                    </select>
                                                </div>
                                            </div>
                                           
                                            <div class="col-md-12"><br /></div>
                                           
                                           

                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Sale Date</label>
                                                    <input name="store_purchase_no" onChange={handleChange} value={formData.store_purchase_no} class="form-control" placeholder="Enter Sale No." type="hidden" />

                                                    <input name="store_purchase_date" onChange={handleChange} value={formData.store_purchase_date} 
                                                    class="form-control" placeholder="Enter Sale Date"
                                                        type="date" />
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div >
                                                    <label for="customername-field" class="form-label">Department</label>
                                                    <input name="store_invoice_number" onChange={handleChange} value={formData.store_invoice_number} class="form-control" placeholder="Enter Department" type="text" />
                                                </div>
                                            </div>
                                       

                                            <div class="col-lg-12">
                                                <br />
                                                  <div className="col-2"></div>
       <div className="col-xxl-8 col-sm-8">
  <div className="custom-search-box d-flex align-items-center">
    <span className="search-icon-box">
      <i className="ri-barcode-line"></i>
    </span>

    <div style={{ width: "100%" }}>
      <input
        type="text"
        className="form-control custom-search-input"
        placeholder="Item name / Barcode / Itemcode"
        value={itemSearch}
        onFocus={() => setShowItemOptions(true)}
        onChange={(e) => {
          setItemSearch(e.target.value);
          setShowItemOptions(true);
        }}
      />

      {/* Searchable dropdown */}
      {showItemOptions && (
        <div className="dropdown-menu show w-100">
          {items
            ?.filter(
              (i) =>
                i.store_item_name.toLowerCase().includes(itemSearch.toLowerCase()) ||
                i.store_item_code?.toLowerCase().includes(itemSearch.toLowerCase())
            )
            .map((i, index) => (
              <div
                key={index}
                className="dropdown-item"
                onClick={() => handleItemSelect(i)}
              >
                {i.store_hsn} - {i.store_item_name} ({i.store_unit})
              </div>
            ))}
        </div>
      )}
    </div>
  </div>
</div>
 <div className="col-2"></div>
                                                <br />
                                                <div class="row">
                                                    <div class="col-lg-8">
                                                        <h6>Items</h6>
                                                    </div>
                                                    <div class="col-lg-4" style={{ textAlign: "right" }}>
                                                        <button type="button"
                                                         onClick={(e) => {
                                                            e.preventDefault();
                                                            var tmp = formData.medicines;
                                                            tmp.push({
                                                                sn: (tmp.length + 1),
                                                                store_purchase_item_name: '',
                                                                store_purchase_item_unit: '',
                                                                store_purchase_item_rate: '',
                                                                store_purchase_item_qty: '',
                                                                store_purchase_item_dis: '',
                                                                store_purchase_item_dis_amt: '',
                                                                store_purchase_item_gst: '',
                                                                store_purchase_item_total: '',
                                                            });

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                medicines: tmp
                                                            }));

                                                        }}
                                                        class="btn btn-primary">Add</button>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                            <div class="col-md-12">
                                                <div class="card-body pt-0">
                                                    <div>

                                                        <div class="table-responsive table-card mb-1">
                                                            <table class="table table-nowrap align-middle" id="orderTable">
                                                                <thead class="text-muted table-light" >
                                                                    <tr class="text-uppercase">

                                                                        <th data-sort="customer_name">Sr. No.</th>
                                                                        <th data-sort="customer_name">Item Name</th>
                                                                        <th data-sort="customer_name">Unit</th>
                                                                        <th data-sort="customer_name">QTY</th>
                                                                        <th data-sort="customer_name">Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="list form-check-all">
                                                                {formData.medicines.map((item, index) => (
                                                                    <tr>
                                                                        <td class="customer_name">{index+1}.</td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_name'+index} 
                                                                                value={item.store_purchase_item_name} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_unit'+index} 
                                                                                value={item.store_purchase_item_unit} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_qty'+index} 
                                                                                value={item.store_purchase_item_qty} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                       
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" name={'store_purchase_item_total'+index} 
                                                                                value={item.store_purchase_item_total} 
                                                                                onChange={(e) => handleChange1(e,index)} />
                                                                        </td>
                                                                    </tr>
                                                                    ))}
                                                                    <tr>
                                                                        <td class="customer_name" colspan="3"></td>
                                                                        <td class="customer_name"><strong>Total</strong></td>
                                                                        <td class="customer_name"><strong>FInal Amount</strong></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class="customer_name" colspan="3"></td>
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" 
                                                                                name="store_purchase_total" 
                                                                                value={formData.store_purchase_total} 
                                                                                onChange={handleChange} />
                                                                        </td>
                                                                        
                                                                        <td class="customer_name">
                                                                            <input type="text" class="form-control" 
                                                                                name="store_purchase_gtotal" 
                                                                                value={formData.store_purchase_gtotal} 
                                                                                onChange={handleChange} />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddPurchase;
